module.exports = __webpack_public_path__ + "static/img/IMG_3767.cceb766.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IMG_3767.jpg
// module id = 284
// module chunks = 0